import { ApolloClient, InMemoryCache, ApolloLink, from } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { BatchHttpLink } from '@apollo/client/link/batch-http';
import typePolicies from './typePolicies';

const create = ({ api, auth, logger }) => {
  const batchLink = new BatchHttpLink({
    uri: `${api}/graphql`,
    batchMax: 50,
  });

  const authentication = new ApolloLink((operation, forward) => {
    operation.setContext({
      headers: {
        authorization: `bearer ${auth.token()}`,
      },
    });
    return forward(operation);
  });

  const authError = onError(err => {
    const { graphQLErrors } = err;

    if (graphQLErrors) {
      for (let index = 0; index < graphQLErrors.length; index += 1) {
        const {
          extensions: { exception },
        } = graphQLErrors[index];
        const error = exception || {};
        const { status } = error;
        if ([401, 403].includes(status)) {
          auth.login({
            redirectUrl: window.location.pathname,
          });
          break;
        }
        if ([400, 404].includes(status)) {
          logger.warn(error);
        } else {
          logger.error(error);
        }
      }
    }
  });

  const client = new ApolloClient({
    ssrMode: true,
    link: from([authError, authentication, batchLink]),

    cache: new InMemoryCache({ typePolicies }),
  });

  return client;
};

export { create };
